import { createContext } from "react";

const usersContext = createContext();

export default usersContext;
